{
  "INTEGRATION_SETTINGS": {
    "SHOPIFY": {
      "DELETE": {
        "TITLE": "Delete Shopify Integration",
        "MESSAGE": "Are you sure you want to delete the Shopify integration?"
      },
      "STORE_URL": {
        "TITLE": "Connect Shopify Store",
        "LABEL": "Store URL",
        "PLACEHOLDER": "your-store.myshopify.com",
        "HELP": "Enter your Shopify store's myshopify.com URL",
        "CANCEL": "Peruuta",
        "SUBMIT": "Connect Store"
      },
      "ERROR": "There was an error connecting to Shopify. Please try again or contact support if the issue persists."
    },
    "HEADER": "Integraatiot",
    "DESCRIPTION": "Yhteyskeskus integroituu useisiin työkaluihin ja palveluihin, jotka tehostavat tiimisi työtä. Tutustu alla olevaan luetteloon ja määritä suosikkisovelluksesi.",
    "LEARN_MORE": "Learn more about integrations",
    "LOADING": "Fetching integrations",
    "CAPTAIN": {
      "DISABLED": "Captain is not enabled on your account.",
      "CLICK_HERE_TO_CONFIGURE": "Click here to configure",
      "LOADING_CONSOLE": "Loading Captain Console...",
      "FAILED_TO_LOAD_CONSOLE": "Failed to load Captain Console. Please refresh and try again."
    },
    "WEBHOOK": {
      "SUBSCRIBED_EVENTS": "Subscribed Events",
      "LEARN_MORE": "Learn more about webhooks",
      "FORM": {
        "CANCEL": "Peruuta",
        "DESC": "Webhook-tapahtumat antavat sinulle reaaliaikaista tietoa siitä, mitä Chatwot-tililläsi tapahtuu. Syötä kelvollinen URL-osoite, jotta voit määrittää callbackin.",
        "SUBSCRIPTIONS": {
          "LABEL": "Events",
          "EVENTS": {
            "INBOX_CREATED": "Saapuneet-kansio luotu",
            "CONVERSATION_CREATED": "Conversation Created",
            "CONVERSATION_STATUS_CHANGED": "Conversation Status Changed",
            "CONVERSATION_UPDATED": "Conversation Updated",
            "MESSAGE_CREATED": "Message created",
            "MESSAGE_UPDATED": "Message updated",
            "WEBWIDGET_TRIGGERED": "Live chat widget opened by the user",
            "CONTACT_CREATED": "Contact created",
            "CONTACT_UPDATED": "Contact updated",
            "JARABOT_EVENT": "Internal events"
          }
        },
        "END_POINT": {
          "LABEL": "Webhookin URL",
          "PLACEHOLDER": "Example: {webhookExampleURL}",
          "ERROR": "Anna kelvollinen URL-osoite"
        },
        "EDIT_SUBMIT": "Update webhook",
        "ADD_SUBMIT": "Luo webhook"
      },
      "TITLE": "Webhook",
      "CONFIGURE": "Määrittele",
      "HEADER": "Webhook-asetukset",
      "HEADER_BTN_TXT": "Lisää uusi webhook",
      "LOADING": "Haetaan liitettyjä webhookeja",
      "SEARCH_404": "Tätä hakua vastaavia kohteita ei löydy",
      "SIDEBAR_TXT": "<p><b>Webhookit</b> </p> <p>Webhookit ovat HTTP-kutsuja, jotka voidaan määritellä jokaiselle tilille. Ne laukaisevat tapahtumia, kuten viestin luonti. Voit luoda useamman kuin yhden webhookin tälle tilille. <br /><br /> Luodaksesi <b>webhookiin</b>, napsauta <b>Lisää uusi Webhook</b> -painiketta. Voit myös poistaa minkä tahansa olemassa olevan Webhookiin klikkaamalla Poista -painiketta.</p>",
      "LIST": {
        "404": "Tälle tilille ei ole määritetty webhookeja.",
        "TITLE": "Hallitse webhookeja",
        "TABLE_HEADER": {
          "WEBHOOK_ENDPOINT": "Webhookin päätepiste",
          "ACTIONS": "Toiminnot"
        }
      },
      "EDIT": {
        "BUTTON_TEXT": "Muokkaa",
        "TITLE": "Edit webhook",
        "API": {
          "SUCCESS_MESSAGE": "Webhook configuration updated successfully",
          "ERROR_MESSAGE": "Yhteyden muodostaminen Woot-palvelimelle ei onnistunut, yritä myöhemmin uudelleen"
        }
      },
      "ADD": {
        "CANCEL": "Peruuta",
        "TITLE": "Lisää uusi webhook",
        "API": {
          "SUCCESS_MESSAGE": "Webhook configuration added successfully",
          "ERROR_MESSAGE": "Yhteyden muodostaminen Woot-palvelimelle ei onnistunut, yritä myöhemmin uudelleen"
        }
      },
      "DELETE": {
        "BUTTON_TEXT": "Poista",
        "API": {
          "SUCCESS_MESSAGE": "Webhook poistettu onnistuneesti",
          "ERROR_MESSAGE": "Yhteyden muodostaminen Woot-palvelimelle ei onnistunut, yritä myöhemmin uudelleen"
        },
        "CONFIRM": {
          "TITLE": "Vahvista poistaminen",
          "MESSAGE": "Are you sure to delete the webhook? ({webhookURL})",
          "YES": "Kyllä, poista ",
          "NO": "Ei, säilytä"
        }
      },
      "DISABLED_BADGE": "Pois käytöstä",
      "DISABLED_REASON": "Poistettu automaattisesti käytöstä {count} peräkkäisen virheen jälkeen. Viimeisin virhe: {error}",
      "ENABLE": {
        "BUTTON_TEXT": "Ota käyttöön",
        "API": {
          "SUCCESS_MESSAGE": "Webhook otettu käyttöön onnistuneesti",
          "ERROR_MESSAGE": "Webhookin käyttöönotto epäonnistui, yritä myöhemmin uudelleen"
        }
      }
    },
    "SLACK": {
      "DELETE": "Poista",
      "DELETE_CONFIRMATION": {
        "TITLE": "Delete the integration",
        "MESSAGE": "Are you sure you want to delete the integration? Doing so will result in the loss of access to conversations on your Slack workspace."
      },
      "HELP_TEXT": {
        "TITLE": "Using Slack Integration",
        "BODY": "Tämän integraation avulla kaikki saapuvat keskustelusi synkronoidaan Slack-työtilasi kanavalle ***{selectedChannelName}***. Voit hallita kaikkia asiakaskeskustelujasi suoraan kanavalla, etkä koskaan menetä viestiä.\n\nIntegraation tärkeimmät ominaisuudet:\n\n**Vastaa keskusteluihin suoraan Slackissa:** Kun haluat vastata keskusteluun Slack-kanavalla ***{selectedChannelName}***, kirjoita viestisi ja lähetä se ketjuna. Vastaus lähtee asiakkaalle yhteyskeskuksen kautta. Se on näin helppoa!\n\n **Luo yksityisiä muistiinpanoja:** Jos haluat luoda yksityisen muistiinpanon vastauksen sijaan, aloita viestisi merkinnällä ***`note:`***. Näin viestisi pysyy yksityisenä, eikä asiakas näe sitä.\n\n**Liitä agenttiprofiili:** Jos Slackissa vastanneella henkilöllä on yhteyskeskuksessa agenttiprofiili samalla sähköpostiosoitteella, vastaukset liitetään automaattisesti tähän agenttiprofiiliin. Näin näet helposti, kuka sanoi mitä ja milloin. Jos vastaajalla ei ole liitettyä agenttiprofiilia, asiakas näkee vastaukset bottiprofiililta.",
        "SELECTED": "selected"
      },
      "SELECT_CHANNEL": {
        "OPTION_LABEL": "Select a channel",
        "UPDATE": "Päivitä",
        "BUTTON_TEXT": "Connect channel",
        "DESCRIPTION": "Slack-työtilasi on nyt yhdistetty yhteyskeskukseen. Integraatio ei kuitenkaan ole vielä aktiivinen. Aktivoi integraatio ja yhdistä kanava napsauttamalla alla olevaa painiketta.\n\n**Huomio:** Jos yhdistät yksityisen kanavan, lisää sovelluksemme Slack-kanavalle ennen tätä vaihetta.",
        "ATTENTION_REQUIRED": "Attention required",
        "EXPIRED": "Your Slack integration has expired. To continue receiving messages on Slack, please delete the integration and connect your workspace again."
      },
      "UPDATE_ERROR": "There was an error updating the integration, please try again",
      "UPDATE_SUCCESS": "The channel is connected successfully",
      "FAILED_TO_FETCH_CHANNELS": "There was an error fetching the channels from Slack, please try again"
    },
    "OPEN_AI": {
      "AI_ASSIST": "AI Assist",
      "WITH_AI": " {option} AI:n avulla ",
      "OPTIONS": {
        "REPLY_SUGGESTION": "Vastausehdotus",
        "SUMMARIZE": "Tiivistä",
        "REPHRASE": "Paranna kirjoitusta",
        "FIX_SPELLING_GRAMMAR": "Korjaa oikeinkirjoitus ja kielioppi",
        "SHORTEN": "Lyhennä",
        "EXPAND": "Laajenna",
        "MAKE_FRIENDLY": "Muuta viestin sävy ystävälliseksi",
        "MAKE_FORMAL": "Käytä muodollista sävyä",
        "SIMPLIFY": "Yksinkertaista",
        "TRANSLATE": "Käännä",
        "TRANSLATE_TO_MAJORITY_LANGUAGE": "Käännä enemmistön kielelle"
      },
      "ASSISTANCE_MODAL": {
        "DRAFT_TITLE": "Luonnoksen sisältö",
        "GENERATED_TITLE": "Luotu sisältö",
        "AI_WRITING": "AI kirjoittaa",
        "BUTTONS": {
          "APPLY": "Käytä tätä ehdotusta",
          "CANCEL": "Peruuta"
        }
      },
      "CTA_MODAL": {
        "TITLE": "Integroi OpenAI:n kanssa",
        "DESC": "Tuo edistyneet AI-ominaisuudet hallintapaneeliisi OpenAI:n GPT-malleilla. Aloita syöttämällä OpenAI-tilisi API-avain.",
        "KEY_PLACEHOLDER": "Syötä OpenAI API-avaimesi",
        "BUTTONS": {
          "NEED_HELP": "Tarvitsetko apua?",
          "DISMISS": "Dismiss",
          "FINISH": "Finish Setup"
        },
        "DISMISS_MESSAGE": "Voit määrittää OpenAI-integraation myöhemmin, milloin tahansa haluat.",
        "SUCCESS_MESSAGE": "OpenAI-integraatio määritetty onnistuneesti"
      },
      "TITLE": "Paranna AI:n avulla",
      "SUMMARY_TITLE": "Yhteenveto AI:n avulla",
      "REPLY_TITLE": "Vastausehdotus AI:n avulla",
      "SUBTITLE": "Parannettu vastaus luodaan AI:n avulla nykyisen luonnoksesi pohjalta.",
      "TONE": {
        "TITLE": "Sävy",
        "OPTIONS": {
          "PROFESSIONAL": "Ammattimainen",
          "FRIENDLY": "Ystävällinen"
        }
      },
      "BUTTONS": {
        "GENERATE": "Luo",
        "GENERATING": "Luodaan...",
        "CANCEL": "Peruuta"
      },
      "GENERATE_ERROR": "Sisällön käsittelyssä tapahtui virhe, tarkista OpenAI API-avain ja yritä uudelleen"
    },
    "DELETE": {
      "BUTTON_TEXT": "Poista",
      "API": {
        "SUCCESS_MESSAGE": "Integrointi poistettu onnistuneesti"
      }
    },
    "CONNECT": {
      "BUTTON_TEXT": "Yhdistä"
    },
    "DASHBOARD_APPS": {
      "TITLE": "Dashboard Apps",
      "HEADER_BTN_TXT": "Add a new dashboard app",
      "SIDEBAR_TXT": "<p><b>Hallintapaneelin sovellukset</b></p><p>Hallintapaneelin sovellusten avulla organisaatiot voivat upottaa sovelluksen hallintapaneeliin ja antaa asiakastuen agenteille lisätietoa. Voit luoda sovelluksen itsenäisesti ja upottaa sen hallintapaneeliin, jotta se näyttää käyttäjän tiedot, tilaukset tai aiemman maksuhistorian.</p><p>Kun upotat sovelluksesi hallintapaneeliin, sovelluksesi saa keskustelun ja yhteystiedon tiedot ikkunatapahtumana. Toteuta sivullesi kuuntelija message-tapahtumalle, jotta saat nämä tiedot.</p><p>Lisää uusi hallintapaneelin sovellus napsauttamalla painiketta 'Lisää uusi hallintapaneelin sovellus'.</p>",
      "DESCRIPTION": "Dashboard Apps allow organizations to embed an application inside the dashboard to provide the context for customer support agents. This feature allows you to create an application independently and embed that to provide user information, their orders, or their previous payment history.",
      "LEARN_MORE": "Learn more about Dashboard Apps",
      "LIST": {
        "404": "There are no dashboard apps configured on this account yet",
        "LOADING": "Fetching dashboard apps...",
        "TABLE_HEADER": {
          "NAME": "Nimi",
          "ENDPOINT": "Endpoint"
        },
        "EDIT_TOOLTIP": "Edit app",
        "DELETE_TOOLTIP": "Delete app"
      },
      "FORM": {
        "TITLE_LABEL": "Nimi",
        "TITLE_PLACEHOLDER": "Enter a name for your dashboard app",
        "TITLE_ERROR": "A name for the dashboard app is required",
        "URL_LABEL": "Endpoint",
        "URL_PLACEHOLDER": "Enter the endpoint URL where your app is hosted",
        "URL_ERROR": "A valid URL is required"
      },
      "CREATE": {
        "HEADER": "Add a new dashboard app",
        "FORM_SUBMIT": "Lähetä",
        "FORM_CANCEL": "Peruuta",
        "API_SUCCESS": "Dashboard app configured successfully",
        "API_ERROR": "We couldn't create an app. Please try again later"
      },
      "UPDATE": {
        "HEADER": "Edit dashboard app",
        "FORM_SUBMIT": "Päivitä",
        "FORM_CANCEL": "Peruuta",
        "API_SUCCESS": "Dashboard app updated successfully",
        "API_ERROR": "We couldn't update the app. Please try again later"
      },
      "DELETE": {
        "CONFIRM_YES": "Yes, delete it",
        "CONFIRM_NO": "No, keep it",
        "TITLE": "Confirm deletion",
        "MESSAGE": "Are you sure to delete the app - {appName}?",
        "API_SUCCESS": "Dashboard app deleted successfully",
        "API_ERROR": "We couldn't delete the app. Please try again later"
      }
    },
    "LINEAR": {
      "ADD_OR_LINK_BUTTON": "Create/Link Linear Issue",
      "LOADING": "Fetching linear issues...",
      "LOADING_ERROR": "There was an error fetching the linear issues, please try again",
      "CREATE": "Luo",
      "LINK": {
        "SEARCH": "Search issues",
        "SELECT": "Select issue",
        "TITLE": "Link",
        "EMPTY_LIST": "No linear issues found",
        "LOADING": "Loading",
        "ERROR": "There was an error fetching the linear issues, please try again",
        "LINK_SUCCESS": "Issue linked successfully",
        "LINK_ERROR": "There was an error linking the issue, please try again",
        "LINK_TITLE": "Conversation (#{conversationId}) with {name}"
      },
      "ADD_OR_LINK": {
        "TITLE": "Create/link linear issue",
        "DESCRIPTION": "Create Linear issues from conversations, or link existing ones for seamless tracking.",
        "FORM": {
          "TITLE": {
            "LABEL": "Title",
            "PLACEHOLDER": "Enter title",
            "REQUIRED_ERROR": "Title is required"
          },
          "DESCRIPTION": {
            "LABEL": "Kuvaus",
            "PLACEHOLDER": "Enter description"
          },
          "TEAM": {
            "LABEL": "Tiimi",
            "PLACEHOLDER": "Valitse tiimi",
            "SEARCH": "Search team",
            "REQUIRED_ERROR": "Team is required"
          },
          "ASSIGNEE": {
            "LABEL": "Assignee",
            "PLACEHOLDER": "Select assignee",
            "SEARCH": "Search assignee"
          },
          "PRIORITY": {
            "LABEL": "Priority",
            "PLACEHOLDER": "Select priority",
            "SEARCH": "Search priority"
          },
          "LABEL": {
            "LABEL": "Label",
            "PLACEHOLDER": "Select label",
            "SEARCH": "Search label"
          },
          "STATUS": {
            "LABEL": "Tila",
            "PLACEHOLDER": "Select status",
            "SEARCH": "Search status"
          },
          "PROJECT": {
            "LABEL": "Project",
            "PLACEHOLDER": "Select project",
            "SEARCH": "Search project"
          }
        },
        "CREATE": "Luo",
        "CANCEL": "Peruuta",
        "CREATE_SUCCESS": "Issue created successfully",
        "CREATE_ERROR": "There was an error creating the issue, please try again",
        "LOADING_TEAM_ERROR": "There was an error fetching the teams, please try again",
        "LOADING_TEAM_ENTITIES_ERROR": "There was an error fetching the team entities, please try again"
      },
      "ISSUE": {
        "STATUS": "Tila",
        "PRIORITY": "Priority",
        "ASSIGNEE": "Assignee",
        "LABELS": "Tunnisteet",
        "CREATED_AT": "Created at {createdAt}"
      },
      "UNLINK": {
        "TITLE": "Unlink",
        "SUCCESS": "Issue unlinked successfully",
        "ERROR": "There was an error unlinking the issue, please try again"
      },
      "DELETE": {
        "TITLE": "Are you sure you want to delete the integration?",
        "MESSAGE": "Are you sure you want to delete the integration?",
        "CONFIRM": "Yes, delete",
        "CANCEL": "Peruuta"
      }
    }
  },
  "CAPTAIN": {
    "NAME": "Captain",
    "HEADER_KNOW_MORE": "Know more",
    "COPILOT": {
      "SEND_MESSAGE": "Lähetä viesti...",
      "EMPTY_MESSAGE": "Vastauksen luomisessa tapahtui virhe. Yritä uudelleen.",
      "LOADER": "Captain is thinking",
      "YOU": "Sinä",
      "USE": "Use this",
      "RESET": "Reset",
      "SELECT_ASSISTANT": "Select Assistant"
    },
    "PAYWALL": {
      "TITLE": "Upgrade to use Captain AI",
      "AVAILABLE_ON": "Captain is not available on the free plan.",
      "UPGRADE_PROMPT": "Upgrade your plan to get access to our assistants, copilot and more.",
      "UPGRADE_NOW": "Upgrade now",
      "CANCEL_ANYTIME": "You can change or cancel your plan anytime"
    },
    "ENTERPRISE_PAYWALL": {
      "AVAILABLE_ON": "Captain AI feature is only available in a paid plan.",
      "UPGRADE_PROMPT": "Upgrade your plan to get access to our assistants, copilot and more.",
      "ASK_ADMIN": "Please reach out to your administrator for the upgrade."
    },
    "BANNER": {
      "RESPONSES": "You've used over 80% of your response limit. To continue using Captain AI, please upgrade.",
      "DOCUMENTS": "Document limit reached. Upgrade to continue using Captain AI."
    },
    "FORM": {
      "CANCEL": "Peruuta",
      "CREATE": "Luo",
      "EDIT": "Päivitä"
    },
    "ASSISTANTS": {
      "HEADER": "Assistants",
      "ADD_NEW": "Create a new assistant",
      "DELETE": {
        "TITLE": "Are you sure to delete the assistant?",
        "DESCRIPTION": "This action is permanent. Deleting this assistant will remove it from all connected inboxes and permanently erase all generated knowledge.",
        "CONFIRM": "Yes, delete",
        "SUCCESS_MESSAGE": "The assistant has been successfully deleted",
        "ERROR_MESSAGE": "There was an error deleting the assistant, please try again."
      },
      "FORM_DESCRIPTION": "Fill out the details below to name your assistant, describe its purpose, and specify the product it will support.",
      "CREATE": {
        "TITLE": "Create an assistant",
        "SUCCESS_MESSAGE": "The assistant has been successfully created",
        "ERROR_MESSAGE": "There was an error creating the assistant, please try again."
      },
      "FORM": {
        "NAME": {
          "LABEL": "Assistant Name",
          "PLACEHOLDER": "Enter a name for the assistant",
          "ERROR": "Please provide a name for the assistant"
        },
        "DESCRIPTION": {
          "LABEL": "Assistant Description",
          "PLACEHOLDER": "Describe how and where this assistant will be used",
          "ERROR": "A description is required"
        },
        "PRODUCT_NAME": {
          "LABEL": "Product Name",
          "PLACEHOLDER": "Enter the name of the product this assistant is designed for",
          "ERROR": "The product name is required"
        },
        "FEATURES": {
          "TITLE": "Ominaisuudet",
          "ALLOW_CONVERSATION_FAQS": "Generate FAQs from resolved conversations",
          "ALLOW_MEMORIES": "Capture key details as memories from customer interactions."
        }
      },
      "EDIT": {
        "TITLE": "Update the assistant",
        "SUCCESS_MESSAGE": "The assistant has been successfully updated",
        "ERROR_MESSAGE": "There was an error updating the assistant, please try again."
      },
      "OPTIONS": {
        "EDIT_ASSISTANT": "Edit Assistant",
        "DELETE_ASSISTANT": "Delete Assistant",
        "VIEW_CONNECTED_INBOXES": "View connected inboxes"
      },
      "EMPTY_STATE": {
        "TITLE": "No assistants available",
        "SUBTITLE": "Create an assistant to provide quick and accurate responses to your users. It can learn from your help articles and past conversations.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain Assistant",
          "NOTE": "Captain Assistant engages directly with customers, learns from your help docs and past conversations, and delivers instant, accurate responses. It handles the initial queries, providing quick resolutions before  transferring to an agent when needed."
        }
      }
    },
    "DOCUMENTS": {
      "HEADER": "Documents",
      "ADD_NEW": "Create a new document",
      "RELATED_RESPONSES": {
        "TITLE": "Related FAQs",
        "DESCRIPTION": "These FAQs are generated directly from the document."
      },
      "FORM_DESCRIPTION": "Enter the URL of the document to add it as a knowledge source and choose the assistant to associate it with.",
      "CREATE": {
        "TITLE": "Add a document",
        "SUCCESS_MESSAGE": "The document has been successfully created",
        "ERROR_MESSAGE": "There was an error creating the document, please try again."
      },
      "FORM": {
        "URL": {
          "LABEL": "URL",
          "PLACEHOLDER": "Enter the URL of the document",
          "ERROR": "Please provide a valid URL for the document"
        },
        "ASSISTANT": {
          "LABEL": "Assistant",
          "PLACEHOLDER": "Select the assistant",
          "ERROR": "The assistant field is required"
        }
      },
      "DELETE": {
        "TITLE": "Are you sure to delete the document?",
        "DESCRIPTION": "This action is permanent. Deleting this document will permanently erase all generated knowledge.",
        "CONFIRM": "Yes, delete",
        "SUCCESS_MESSAGE": "The document has been successfully deleted",
        "ERROR_MESSAGE": "There was an error deleting the document, please try again."
      },
      "OPTIONS": {
        "VIEW_RELATED_RESPONSES": "View Related Responses",
        "DELETE_DOCUMENT": "Delete Document"
      },
      "EMPTY_STATE": {
        "TITLE": "No documents available",
        "SUBTITLE": "Documents are used by your assistant to generate FAQs. You can import documents to provide context for your assistant.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain Document",
          "NOTE": "A document in Captain serves as a knowledge resource for the assistant. By connecting your help center or guides, Captain can analyze the content and provide accurate responses for customer inquiries."
        }
      }
    },
    "RESPONSES": {
      "HEADER": "FAQs",
      "ADD_NEW": "Create new FAQ",
      "DOCUMENTABLE": {
        "CONVERSATION": "Conversation #{id}"
      },
      "SELECTED": "{count} selected",
      "BULK_APPROVE_BUTTON": "Approve",
      "BULK_DELETE_BUTTON": "Poista",
      "BULK_APPROVE": {
        "SUCCESS_MESSAGE": "FAQs approved successfully",
        "ERROR_MESSAGE": "There was an error approving the FAQs, please try again."
      },
      "BULK_DELETE": {
        "TITLE": "Delete FAQs?",
        "DESCRIPTION": "Are you sure you want to delete the selected FAQs? This action cannot be undone.",
        "CONFIRM": "Yes, delete all",
        "SUCCESS_MESSAGE": "FAQs deleted successfully",
        "ERROR_MESSAGE": "There was an error deleting the FAQs, please try again."
      },
      "DELETE": {
        "TITLE": "Are you sure to delete the FAQ?",
        "DESCRIPTION": "",
        "CONFIRM": "Yes, delete",
        "SUCCESS_MESSAGE": "FAQ deleted successfully",
        "ERROR_MESSAGE": "There was an error deleting the FAQ, please try again."
      },
      "FILTER": {
        "ASSISTANT": "Assistant: {selected}",
        "STATUS": "Status: {selected}",
        "ALL_ASSISTANTS": "Kaikki"
      },
      "STATUS": {
        "TITLE": "Tila",
        "PENDING": "Odottava",
        "APPROVED": "Approved",
        "ALL": "Kaikki"
      },
      "FORM_DESCRIPTION": "Add a question and its corresponding answer to the knowledge base and select the assistant it should be associated with.",
      "CREATE": {
        "TITLE": "Add an FAQ",
        "SUCCESS_MESSAGE": "The response has been added successfully.",
        "ERROR_MESSAGE": "An error occurred while adding the response. Please try again."
      },
      "FORM": {
        "QUESTION": {
          "LABEL": "Question",
          "PLACEHOLDER": "Enter the question here",
          "ERROR": "Please provide a valid question."
        },
        "ANSWER": {
          "LABEL": "Answer",
          "PLACEHOLDER": "Enter the answer here",
          "ERROR": "Please provide a valid answer."
        },
        "ASSISTANT": {
          "LABEL": "Assistant",
          "PLACEHOLDER": "Select an assistant",
          "ERROR": "Please select an assistant."
        }
      },
      "EDIT": {
        "TITLE": "Update the FAQ",
        "SUCCESS_MESSAGE": "The FAQ has been successfully updated",
        "ERROR_MESSAGE": "There was an error updating the FAQ, please try again",
        "APPROVE_SUCCESS_MESSAGE": "The FAQ was marked as approved"
      },
      "OPTIONS": {
        "APPROVE": "Mark as approved",
        "EDIT_RESPONSE": "Edit FAQ",
        "DELETE_RESPONSE": "Delete FAQ"
      },
      "EMPTY_STATE": {
        "TITLE": "No FAQs Found",
        "SUBTITLE": "FAQs help your assistant provide quick and accurate answers to questions from your customers. They can be generated automatically from your content or can be added manually.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain FAQ",
          "NOTE": "Captain FAQs detects common customer questions—whether missing from your knowledge base or frequently asked—and generates relevant FAQs to improve support. You can review each suggestion and decide whether to approve or reject it."
        }
      }
    },
    "INBOXES": {
      "HEADER": "Connected Inboxes",
      "ADD_NEW": "Connect a new inbox",
      "OPTIONS": {
        "DISCONNECT": "Disconnect"
      },
      "DELETE": {
        "TITLE": "Are you sure to disconnect the inbox?",
        "DESCRIPTION": "",
        "CONFIRM": "Yes, delete",
        "SUCCESS_MESSAGE": "The inbox was successfully disconnected.",
        "ERROR_MESSAGE": "There was an error disconnecting the inbox, please try again."
      },
      "FORM_DESCRIPTION": "Choose an inbox to connect with the assistant.",
      "CREATE": {
        "TITLE": "Connect an Inbox",
        "SUCCESS_MESSAGE": "The inbox was successfully connected.",
        "ERROR_MESSAGE": "An error occurred while connecting the inbox. Please try again."
      },
      "FORM": {
        "INBOX": {
          "LABEL": "Inbox",
          "PLACEHOLDER": "Choose the inbox to deploy the assistant.",
          "ERROR": "An inbox selection is required."
        }
      },
      "EMPTY_STATE": {
        "TITLE": "No Connected Inboxes",
        "SUBTITLE": "Connecting an inbox allows the assistant to handle initial questions from your customers before transferring them to you."
      }
    }
  }
}
